export class Billing {
  id: number;
  activity_id: number;
  matter_id: number;
  user_id: number;
  bill_id: number;
  is_billable: boolean;
  quantity: number;
  rate: number;
  description: string | null;
  created_at: string;
  updated_at: string;
  created_by: number;
  updated_by: number;
  is_hourly: boolean;
  is_authorized: boolean;
  is_rejected: boolean;
  rendered_at: string;
  intranet_id: number;
  activity_rate_id: number;
  activity_matter_rate_id: number;
  document_id: number | null | undefined;
  parent_history_id: number;
  quantity_actual: number;
  charge: number;
  reminder_date: string;
  history_message: string;
  other_emails: string;
  title: string;
  is_paid: boolean;
  user_name: string;
  created_at_date: any;
  created_at_time: any;
  invoice_id: number;
  amount: any;
  notify_accounting: boolean;
}
